import { prefetchOnHover } from "routes/prefetch";
import {
  ScriptEditorPanel as LazyScriptEditorPanel,
  CoveragePanel as LazyCoveragePanel,
  NotesPanel as LazyNotesPanel,
  TagsPanel as LazyTagsPanel,
  ReportPanel as LazyReportPanel,
  CharacterBreakdownPanel as LazyCharacterBreakdownPanel,
  CharacterSummaryPanel as LazyCharacterSummaryPanel,
  ActorsManagementPanel as LazyActorsManagementPanel,
  Stripboard as LazyStripboard,
  DayOutOfDays as LazyDayOutOfDays,
  ShootingCalendar as LazyShootingCalendar,
  RoadmapBoard as LazyRoadmapBoard,
  Budget as LazyBudget,
  Actuals as LazyActuals,
  Fringes as LazyFringes,
  TaxIncentives as LazyTaxIncentives,
} from "routes/panels";

/**
 * Hover and focus handlers that preload each step page's lazy chunk, keyed by
 * the item id from the navigation config. Kept out of the config so the
 * config stays free of route modules.
 */
export const PROJECT_NAV_ITEM_PREFETCH: Record<string, Record<string, unknown>> = {
  "script-breakdown": prefetchOnHover(LazyScriptEditorPanel as never, "script/breakdown"),
  "script-coverage": prefetchOnHover(LazyCoveragePanel as never, "script/coverage"),
  "script-notes": prefetchOnHover(LazyNotesPanel as never, "script/notes"),
  "script-tags": prefetchOnHover(LazyTagsPanel as never, "script/tags"),
  "script-report": prefetchOnHover(LazyReportPanel as never, "script/report"),
  "characters-breakdown": prefetchOnHover(
    LazyCharacterBreakdownPanel as never,
    "characters/breakdown"
  ),
  "characters-summary": prefetchOnHover(LazyCharacterSummaryPanel as never, "characters/summary"),
  "characters-actors": prefetchOnHover(LazyActorsManagementPanel as never, "characters/actors"),
  "schedule-stripboard": prefetchOnHover(LazyStripboard as never, "schedule/stripboard"),
  "schedule-roadmap": prefetchOnHover(LazyRoadmapBoard as never, "schedule/roadmap"),
  "schedule-boneyard": prefetchOnHover(LazyStripboard as never, "schedule/boneyard"),
  "schedule-day-out-of-days": prefetchOnHover(LazyDayOutOfDays as never, "schedule/dayoutofdays"),
  "schedule-shooting-calendar": prefetchOnHover(
    LazyShootingCalendar as never,
    "schedule/shootingcalendar"
  ),
  "budget-production-budget": prefetchOnHover(LazyBudget as never, "budget/breakdown"),
  "budget-fringes": prefetchOnHover(LazyFringes as never, "budget/fringes"),
  "budget-actuals": prefetchOnHover(LazyActuals as never, "budget/actuals"),
  "budget-tax-incentives": prefetchOnHover(LazyTaxIncentives as never, "budget/taxincentives"),
};
